import useUserStore from '@/store/modules/user'
import { PAGE_TOP_QUICK_MENU_PERMS } from '@/config/pageTopQuickMenuPerms'

/**
 * 字符权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkPermi(value) {
  if (value && value instanceof Array && value.length > 0) {
    const permissions = useUserStore().permissions
    const permissionDatas = value
    const all_permission = "*:*:*";

    const hasPermission = permissions.some(permission => {
      return all_permission === permission || permissionDatas.includes(permission)
    })

    if (!hasPermission) {
      return false
    }
    return true
  } else {
    console.error(`need roles! Like checkPermi="['system:user:add','system:user:edit']"`)
    return false
  }
}

/**
 * PageTop 快捷入口：父组件 :menus 仅为「本页候选」；是否展示由组件内 permissions 与 PAGE_TOP_QUICK_MENU_PERMS 决定。
 * 未在配置中声明 perms 的 tab 一律不展示（避免无权限占位）。
 */
export function canShowPageTopQuickItem(tabKey, menusProp) {
  const list = Array.isArray(menusProp) ? menusProp : []
  if (!list.includes(tabKey)) return false
  const required = PAGE_TOP_QUICK_MENU_PERMS[tabKey]
  if (!required || !required.length) return false
  return checkPermi(required)
}

/**
 * 角色权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkRole(value) {
  if (value && value instanceof Array && value.length > 0) {
    const roles = useUserStore().roles
    const permissionRoles = value
    const super_admin = "admin";

    const hasRole = roles.some(role => {
      return super_admin === role || permissionRoles.includes(role)
    })

    if (!hasRole) {
      return false
    }
    return true
  } else {
    console.error(`need roles! Like checkRole="['admin','editor']"`)
    return false
  }
}
